import { IntlProvider } from 'react-intl';
import { setLocale } from 'yup';
import * as Yup from 'yup';
import messages from '../../../i18n/base-en';

const getRegisterValidationSchema = (intlData: IntlProvider.Props) => {
  const { intl } = new IntlProvider({ ...intlData }, {}).getChildContext();
  const { formatMessage } = intl;

  setLocale({
    mixed: {
      required: formatMessage(messages.required_valid_error)
    },
    string: {
      email: formatMessage(messages.email_valid_error)
    }
  });

  const registerValidationSchema = Yup.object().shape({
    firstName: Yup.string()
      .matches(/^.{2,}$/, { message: formatMessage(messages.min_length_error, { min: 2 }), excludeEmptyString: true })
      .required(),
    lastName: Yup.string()
      .matches(/^.{2,}$/, { message: formatMessage(messages.min_length_error, { min: 2 }), excludeEmptyString: true })
      .required(),
    email: Yup.string()
      .email()
      .required(),
    password: Yup.string()
      .matches(/^.{6,}$/, { message: formatMessage(messages.min_length_error, { min: 6 }), excludeEmptyString: true })
      .required(),
    passwordConfirm: Yup.string()
      .oneOf([Yup.ref('password'), null], formatMessage(messages.passwords_match_valid_error))
      .required(),
  });

  return Yup.object().shape({ register: registerValidationSchema });

};

export default getRegisterValidationSchema;
